import { Box, Typography, Paper, Chip } from '@mui/material';
import styles from './RecentProjects.module.scss';
import classNames from 'classnames/bind';
import { IInsights } from '~/utils/interface/report';

const cx = classNames.bind(styles);

interface RecentProjectsProps {
  insights: IInsights | null;
}
const RecentProjects = ({ insights }: RecentProjectsProps) => {

  return (
    <Paper className={cx('projects-root')} elevation={3}>
      <Typography variant="h6" className={cx('projects-title')}>Recent Projects</Typography>
      <Box>
        {insights?.projects.map((p) => (
          <Box key={p.uniqueCode} className={cx('project-row')}>
            <Box className={cx('project-info-line')}>
              <Typography className={cx('project-name')}>{p.customerName || '-'}</Typography>
              <Typography className={cx('project-value')}>${p.value}</Typography>
            </Box>
            <Box className={cx('project-info-line')}>
              <Typography className={cx('project-job')}>{p.uniqueCode}</Typography>
              <div className={cx('project-status-container')}>
                <Typography className={cx('project-status-label')}>Status:</Typography>
                <Chip
                  label={p.status}
                  size="small"
                  className={cx('project-status', {
                    'status-inprogress': p.status.toLowerCase() === 'in progress',
                    'status-completed': p.status.toLowerCase() === 'completed',
                    'status-pending': p.status.toLowerCase() === 'pending',
                  })}
                />
              </div>
            </Box>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default RecentProjects;
